import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_asqn94k6h7: FaireBrandEntity = {
  token: "b_asqn94k6h7",
  type: "brand",
  name: "La Miel",
  avatarUrl:
    "https://cdn.faire.com/fastly/7a070e8d3db8fd439fa4eee26b3be1e9073e45b6b6801e0bc2e225d7ac5701e7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/2ef05291612d38c910e543d9988911fbf30298214db5409b6789f786524afe9e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7a070e8d3db8fd439fa4eee26b3be1e9073e45b6b6801e0bc2e225d7ac5701e7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/2ef05291612d38c910e543d9988911fbf30298214db5409b6789f786524afe9e.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 50,
  rating: 4.9,
  reviewCount: 341,
  isTopShop: true,
  isInsider: true,
  description:
    "La Miel\n\nOur clothing is a curated collection of Women’s & Young Contemporary pieces with you in mind. We select modern, chic and sophisticated styles we know you’ll adore, offering a range of basic minimalist pieces to lavish statement dresses. We emphasize superior construction and high-end finishes to make your LA MIEL purchase a true representation of affordable luxury.\n\nBorn in California and serving customers all over the world, we strive everyday to make your shopping experience effortless and convenient. If you have further questions regarding sizing or styling, please feel free to reach out to our styling team via Faire message and we’ll be happy to further assist you. Until then, we look forward to spreading our love and passion for fashion with you!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:19.218Z",
    importedBy: "entity-db-cli",
  },
};
